import React from 'react'
import { useNavigate } from 'react-router-dom';

function CardServicio({ id, titulo, descripcion, img,categoriaServicios }) {
  const isEven = id % 2 === 0;
  const navigate = useNavigate();
  const handleRedirect = (id, titulo) => {
    let cambiado = titulo.replace(/ /g, '_');
    navigate(`/post-venta/${cambiado}`, {state:{idS:id,categoriaServicios:categoriaServicios}} )
    }
  return (
    <div className={`flex flex-col md:flex-row items-center justify-between mb-12 ${isEven ? 'md:flex-row-reverse' : ''}`}>
    <div className="flex flex-col justify-center items-center md:w-1/2 p-4 text-center">
      <h2 className="text-2xl font-bold mb-4 w-full">
        {titulo}
        <span className="block border-b-4 border-Verde w-full mt-2"></span>
      </h2>
      <p className="mb-6 text-GrisOscuro">
        {descripcion}
      </p>
      <button onClick={() => handleRedirect(id,titulo)} className="bg-Verde text-white font-bold py-2 px-6 rounded-lg w-fit">
        Ver más
      </button>
    </div>
    <div className="md:w-1/2 p-4">
      <img src={img} alt="Imagen de servicio" className="w-full h-72 object-cover rounded-lg shadow-carritoshadow" />
    </div>
  </div>
  )
}

export default CardServicio